export default __webpack_public_path__ + "static/media/whatsapp-icon.cda991de.svg";